import { render } from "./VendorWorkHistory.vue?vue&type=template&id=272692d9&scoped=true"
import script from "./VendorWorkHistory.vue?vue&type=script&lang=js"
export * from "./VendorWorkHistory.vue?vue&type=script&lang=js"

import "./VendorWorkHistory.vue?vue&type=style&index=0&id=272692d9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272692d9"]])

export default __exports__